// extracted by mini-css-extract-plugin
export default {"tooltip":"iR-z","arrow":"jR-z"};